import { css } from 'lit';
export default css `
  :host {
    display: block;
    --public-label-width: 84px;
  }

  .textarea-container {
    position: relative;
  }

  sl-textarea {
    --sl-input-font-size-medium: 14px;
    --sl-input-font-weight: 400;
    --sl-input-height-medium: 40px;

    --sl-input-letter-spacing: -0.2px;
    --sl-input-color: var(--amityeko-color-gray-1);

    --sl-input-background-color: #ffffff;

    --sl-input-border-width: 1px;
    --sl-input-border-color: var(--amityeko-color-gray-8);
    --sl-input-border-color-hover: var(--amityeko-color-gray-8);
    --sl-input-border-color-focus: var(--amityeko-color-primary-3);

    --sl-input-border-radius-medium: var(--amityeko-radius-small);

    --sl-input-placeholder-color: var(--amityeko-color-gray-6);
    --sl-input-placeholder-color-disabled: var(--amityeko-color-gray-7);
    --sl-input-required-content: none;

    /* This is required to redefine SL behavior (or active:not(hover) will be a default SL color) */
    --sl-focus-ring: 0 0 0 4px var(--amityeko-color-primary-1);
  }

  sl-textarea::part(textarea) {
    padding: 9px 15px;
    line-height: 20px;
    caret-color: var(--amityeko-color-primary-6);
  }

  sl-textarea::part(base):hover {
    box-shadow: 0 0 0 4px var(--amityeko-color-primary-1);
  }

  sl-textarea[disabled]::part(base):hover {
    box-shadow: none;
    outline: none;
  }

  sl-textarea::part(form-control) {
    display: flex;
    align-items: center;
  }

  sl-textarea::part(form-control-label) {
    flex: 0 0 auto;
    width: var(--public-label-width, 84px);
  }

  sl-textarea::part(form-control-input) {
    flex: 1 1 auto;
    width: 100%;
  }

  .count {
    position: absolute;
    bottom: 10px;
    right: 15px;
  }

  .label {
    display: inline-block;
  }
`;
//# sourceMappingURL=styles.js.map